import { render, staticRenderFns } from "./CustomContactForm.vue?vue&type=template&id=70e94bbe"
import script from "./CustomContactForm.vue?vue&type=script&lang=js"
export * from "./CustomContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScContactForm: require('/opt/build/repo/node_modules/@evince/site/lib/packages/contact/Form.vue').default})
